module.exports = __webpack_public_path__ + "img/video-arrow-overlay.ee94f2e1.png";